import { render, staticRenderFns } from "./PassengerList.vue?vue&type=template&id=40b6fe12&scoped=true"
import script from "./PassengerList.vue?vue&type=script&lang=js"
export * from "./PassengerList.vue?vue&type=script&lang=js"
import style0 from "./PassengerList.vue?vue&type=style&index=0&id=40b6fe12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b6fe12",
  null
  
)

export default component.exports